import { api } from '@/axios/instance/api';

export const apiDeleteDocusignIntegration = (payload) => api.delete(`docusign/integrations/${payload.id}`);
export const apiFetchDocuSignUserIntegrations = (id) => api.get(`docusign/integrations?user__id=${id}`);
